import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

const TermsPage = () => {
  return (
    <div className="min-h-screen bg-slate-50" data-testid="terms-page">
      <div className="bg-[#001f3f] text-white py-12">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <Link to="/" className="inline-flex items-center text-slate-300 hover:text-white mb-4 transition-colors">
            <ArrowLeft className="h-4 w-4 mr-2" />
            Back to Home
          </Link>
          <h1 className="text-4xl md:text-5xl font-bold tracking-tight uppercase heading-font">
            Terms of Service
          </h1>
          <p className="text-slate-300 mt-2">Last updated: March 23, 2026</p>
        </div>
      </div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="bg-white p-8 md:p-12 shadow-lg rounded-lg prose max-w-none">
          
          <h2 className="text-2xl font-bold text-[#001f3f] mb-4">1. Acceptance of Terms</h2>
          <p className="text-slate-700 mb-6">
            By accessing or using the SheLovesThee website (shelovesthee.com) and services, you agree to be bound by these Terms of Service ("Terms"). If you do not agree to these Terms, please do not use our services.
          </p>

          <h2 className="text-2xl font-bold text-[#001f3f] mb-4">2. Description of Service</h2>
          <p className="text-slate-700 mb-6">
            SheLovesThee is a digital media platform providing news, analysis, and community features focused on HBCU (Historically Black Colleges and Universities) sports, with emphasis on the SWAC conference and Jackson State athletics. Our services include news articles, discussion forums, polls, predictions, and social features.
          </p>

          <h2 className="text-2xl font-bold text-[#001f3f] mb-4">3. User Accounts</h2>
          <p className="text-slate-700 mb-4">To access certain features, you may need to create an account. You agree to:</p>
          <ul className="list-disc pl-6 text-slate-700 mb-6 space-y-2">
            <li>Provide accurate and complete information</li>
            <li>Maintain the security of your account credentials</li>
            <li>Accept responsibility for all activities under your account</li>
            <li>Notify us immediately of any unauthorized use</li>
          </ul>

          <h2 className="text-2xl font-bold text-[#001f3f] mb-4">4. User Content</h2>
          <p className="text-slate-700 mb-4">
            You may post comments, messages, and other content ("User Content") on our platform. By posting User Content, you:
          </p>
          <ul className="list-disc pl-6 text-slate-700 mb-6 space-y-2">
            <li>Grant us a non-exclusive, royalty-free license to use, display, and distribute your content</li>
            <li>Represent that you own or have the right to post the content</li>
            <li>Agree not to post content that is illegal, harmful, or violates others' rights</li>
          </ul>

          <h2 className="text-2xl font-bold text-[#001f3f] mb-4">5. Prohibited Conduct</h2>
          <p className="text-slate-700 mb-4">You agree NOT to:</p>
          <ul className="list-disc pl-6 text-slate-700 mb-6 space-y-2">
            <li>Post false, misleading, defamatory, or harassing content</li>
            <li>Use hate speech, threats, or discriminatory language</li>
            <li>Impersonate others or misrepresent your affiliation</li>
            <li>Spam, advertise, or solicit without permission</li>
            <li>Upload viruses or malicious code</li>
            <li>Attempt to gain unauthorized access to our systems</li>
            <li>Violate any applicable laws or regulations</li>
            <li>Scrape, harvest, or collect user data without consent</li>
          </ul>

          <h2 className="text-2xl font-bold text-[#001f3f] mb-4">6. Content Moderation</h2>
          <p className="text-slate-700 mb-6">
            We reserve the right to remove any User Content that violates these Terms or that we deem inappropriate, without prior notice. We may also suspend or terminate accounts that repeatedly violate our policies.
          </p>

          <h2 className="text-2xl font-bold text-[#001f3f] mb-4">7. Intellectual Property</h2>
          <p className="text-slate-700 mb-6">
            All content on SheLovesThee, including text, graphics, logos, images, and software, is owned by SheLovesThee or its licensors and is protected by copyright and trademark laws. You may not reproduce, distribute, or create derivative works without our written permission.
          </p>

          <h2 className="text-2xl font-bold text-[#001f3f] mb-4">8. Third-Party Services</h2>
          <p className="text-slate-700 mb-6">
            Our platform may integrate with third-party services (Google, Facebook, Twitter/X, Instagram) for authentication and social features. Your use of these services is subject to their respective terms and privacy policies. We are not responsible for third-party services.
          </p>

          <h2 className="text-2xl font-bold text-[#001f3f] mb-4">9. Advertising</h2>
          <p className="text-slate-700 mb-6">
            SheLovesThee may display advertisements, including ads served by Google AdSense. By using our Site, you agree to the display of such advertisements. We are not responsible for the content of third-party advertisements.
          </p>

          <h2 className="text-2xl font-bold text-[#001f3f] mb-4">10. Disclaimer of Warranties</h2>
          <p className="text-slate-700 mb-6">
            OUR SERVICES ARE PROVIDED "AS IS" AND "AS AVAILABLE" WITHOUT WARRANTIES OF ANY KIND, EXPRESS OR IMPLIED. WE DO NOT GUARANTEE THAT OUR SERVICES WILL BE UNINTERRUPTED, ERROR-FREE, OR SECURE.
          </p>

          <h2 className="text-2xl font-bold text-[#001f3f] mb-4">11. Limitation of Liability</h2>
          <p className="text-slate-700 mb-6">
            TO THE MAXIMUM EXTENT PERMITTED BY LAW, SHELOVESTHEE SHALL NOT BE LIABLE FOR ANY INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES ARISING FROM YOUR USE OF OUR SERVICES.
          </p>

          <h2 className="text-2xl font-bold text-[#001f3f] mb-4">12. Indemnification</h2>
          <p className="text-slate-700 mb-6">
            You agree to indemnify and hold harmless SheLovesThee and its affiliates from any claims, damages, or expenses arising from your violation of these Terms or your use of our services.
          </p>

          <h2 className="text-2xl font-bold text-[#001f3f] mb-4">13. Changes to Terms</h2>
          <p className="text-slate-700 mb-6">
            We may modify these Terms at any time. We will notify users of material changes by posting the updated Terms on our Site. Your continued use of our services after changes constitutes acceptance of the modified Terms.
          </p>

          <h2 className="text-2xl font-bold text-[#001f3f] mb-4">14. Governing Law</h2>
          <p className="text-slate-700 mb-6">
            These Terms shall be governed by and construed in accordance with the laws of the State of Mississippi, without regard to conflict of law principles.
          </p>

          <h2 className="text-2xl font-bold text-[#001f3f] mb-4">15. Contact Information</h2>
          <p className="text-slate-700 mb-4">
            For questions about these Terms, please contact us at:
          </p>
          <div className="bg-slate-100 p-4 rounded-lg">
            <p className="text-slate-700"><strong>SheLovesThee Podcast</strong></p>
            <p className="text-slate-700">Email: contact@shelovesthee.com</p>
            <p className="text-slate-700">Website: https://shelovesthee.com</p>
          </div>

          <div className="mt-8 p-6 bg-[#001f3f] text-white rounded-lg text-center">
            <p className="font-bold">By using SheLovesThee, you acknowledge that you have read, understood, and agree to be bound by these Terms of Service.</p>
          </div>

        </div>
      </div>
    </div>
  );
};

export default TermsPage;
